import { render } from "./AuthView.vue?vue&type=template&id=235695ac"
const script = {}

import exportComponent from "/home/dbomfim/projects/mstr2023/appv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__